import { useCallback, useRef } from 'react';
import type { TaskBodyProps } from '../index';

type BeforeCloseHandler = () => Promise<void>;

// Passes the Dx editor's flush on to TaskSurface and keeps it, so a body-owned action
// can save pending Dx edits before it fires.
export function useBeforeCloseFlush(onRegisterBeforeClose: TaskBodyProps['onRegisterBeforeClose']) {
    const flushRef = useRef<BeforeCloseHandler | null>(null);
    const registerBeforeClose = useCallback(
        (handler: BeforeCloseHandler | null) => {
            flushRef.current = handler;
            onRegisterBeforeClose?.(handler);
        },
        [onRegisterBeforeClose]
    );
    const flush = useCallback(async () => {
        await flushRef.current?.();
    }, []);
    return { registerBeforeClose, flush };
}
